const en = {
	risk: {
		riskTitle: 'Whitelist',
		group: 'Group',
		store: 'Website',
		type: 'Type',
		status: 'Status',
		invalidText: 'When a cardholder submits a new transaction, the rule will be disable.',
		enableText: 'The whitelist rule will take effect immediately',
		title_enable: 'ENABLE',
		title_invalid: 'DISABLE',
		success: 'The operation was successful',
		notUpload: "You haven't uploaded the file, you can' t submit it!",
		downloadFile: 'DOWNLOAD TEMPLATE',
		bulkUploadText: 'Please download the template file first, and fill in as required before uploading',
		bulkTitle: 'Bulk Add',
		data: 'Data',
		country: 'Country',
		state: 'Province / State',
		city: 'City',
		adrress: 'Street',
		format: 'Both formats are available:',
		format1: '1.Complete card number, eg. “1234567890123456”',
		format2: '2.First 6 digits-****-last 4 digits',
		applyTo: 'All websites',
		applyAll: 'When new websites are added into current groups in the future, current rule will be automatically generated',
		cancel: 'Cancel',
		confirm: 'Confirm',
		save: 'Save',
		tip: 'If the approved whitelist is at risk in the future, PingPong Checkout has the right to invalidate it.',

		Reviewing: 'Pending',
		FirstPass: 'Review',
		Effective: 'Enable',
		Ineffective: 'Disable',
		Reject: 'Decline',
		deleteTextTitle: 'Delete Whitelist',
		deleteTextDesc: 'The record cannot be recovered after deletion. Are you sure to delete this whitelist rule?',

		addWhiteRule: 'Add new rule',
		editWhiteRule: 'Edit rule'
	},
	button: {
		add: 'Add new rule',
		bulkAdd: 'BULK ADD',
		enable: 'ENABLE',
		disable: 'DISABLE',
		introduction: 'Whitelist type introduction',
		delete: 'Delete',
		cancel: 'Cancel',
		confirm: 'Confirm'

	},
	table: {
		type: 'Type',
		rule: 'Rule',
		store: 'Store name',
		createTime: 'Created time',
		updateTime: 'Updated time',
		operator: 'Operator',
		status: 'Status',
		action: 'Action',
		edit: 'Edit',
		delete: 'Delete',
		comment: 'Comment'

	},
	introduction: {
		title: 'Whitelist type introduction',
		tip1: 'Once the transaction information exactly matches the whitelist rule，the transaction will be released.',
		tip2: 'You can only see and manage the websites you assigned.',
		q1: '1. Whitelist dimension interpretation',
		q2: '2. Where to find the above information?',
		q2Desc: "Find the menu bar, click: Transaction -> Transaction Log -> transaction pipeline number, jump to the 'Transaction Details' page",
		q3: '3. Where to find the Acc ID？',
		q3Desc: 'Find the menu bar ‘Website Management’ and find the website you want to configure the whitelist rules. Acc ID as shown below:',
		card: 'Card No.',
		card_desc: 'Complete card number、First 6 digits-****-last 4 digits',
		card_example: '1234567890123456、123456****1234',
		phone: 'Phone',
		phone_desc: 'Shipping phone',
		phone_example: '8617700000000',
		email: 'Email',
		email_desc: 'Shipping email',
		email_example: 'XXX@hotmail.com',
		emailDomain: 'Domain name',
		emailDomain_desc: 'Shipping domain name',
		emailDomain_example: 'hotmail.com',
		address: 'Shipping Address',
		address_desc: 'Shipping address',
		address_example: '400,Fifth Avenue, New York City,State of New York,United States',
		type: 'Type',
		desc: 'Description',
		example: 'Example',
		comfirm: 'Comfirm'
	}
}

export default en
